import React from 'react';
import { useSelector } from 'react-redux';

import { Post } from '../../components/Post';
import { sanitizePostContent, usePreparedContent } from '../../utils';
import { selectPostPreview } from '../../selectors/postPreview';
import { ERequestStatus } from '../../types/requestStatus';
import { EType } from '../../repositories/journal/entities/journal/JournalAttributesSchema';

export const PostPreviewContainer = () => {
  const postPreview = useSelector(selectPostPreview);

  usePreparedContent(postPreview, false);

  if (postPreview.status !== ERequestStatus.Succeed) {
    return null;
  }

  const {
    id,
    attributes: { numViews, title, image, datePublish, subtitle, content, preparedContent, type },
  } = postPreview;

  return (
    <Post
      content={sanitizePostContent(preparedContent || content || '')}
      dateModified={datePublish}
      datePublished={datePublish}
      image={image}
      numViews={numViews}
      postId={id}
      postUrl={'/'}
      postCommentsUrl={'/'}
      subtitle={[EType.Articles, EType.News].includes(type) ? subtitle : undefined}
      title={title}
      type={type}
    />
  );
};
